<div class="modal-header">
    <h4 class="modal-title">{{ data.message ? 'Modifier Message' : 'Ajouter Message' }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="closeModal()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>

<div class="modal-body">
    <div class="placeholder-info" *ngIf="type === 1">
        <p><strong>Mots clés disponibles:</strong></p>
        <ul>
            <li><strong>[[clientName]]</strong>: Nom du client</li>
            <li><strong>[[phone]]</strong>: Numéro de téléphone du client</li>
            <li><strong>[[amount]]</strong>: prix de colis</li>
            <li><strong>[[nid]]</strong>: numéro de colis</li>
            <li><strong>[[expediteur]]</strong>: nom de l'expéditeur</li>
        </ul>
    </div>
    
    <form [formGroup]="messageForm" (ngSubmit)="onSubmit()">
        <div class="form-group">
            <label for="messageType">Type</label>
            <select id="messageType" class="form-control" formControlName="messageType" disabled>
                <option value="1">Message</option>
                <option value="2">Alerte</option>
            </select>
        </div>
    
        <div class="form-group">
            <label for="messageText">Message</label>
            <textarea id="messageText" class="form-control" formControlName="text" rows="4"></textarea>
            <div *ngIf="messageForm.get('text').invalid && messageForm.get('text').touched" class="text-danger">
                Le message est obligatoire.
            </div>
        </div>

        <div class="form-group form-check">
            <input type="checkbox" class="form-check-input" id="important" formControlName="isDisplayed">
            <label class="form-check-label" for="important">Affiché</label>
        </div>
        
        <div class="form-group" *ngIf="type === 2">
            <label for="messageDate">Afficher jusqu'à</label>
            <div class="input-group">
                <input type="date" id="messageDate" class="form-control" formControlName="displayUntil">
                <div class="input-group-append">
                  <button type="button" class="btn btn-outline-danger" (click)="resetDisplayUntilDate()">
                    &#x2715;
                  </button>
                </div>
              </div>
        </div>
    </form>
</div>

<div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="closeModal()">Annuler</button>
    <button type="button" class="btn btn-primary" [disabled]="messageForm.invalid" (click)="onSubmit()">
        {{ data.message ? 'Modifier' : 'Ajouter' }}
    </button>
</div>